import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fmtInr, itemsTotals } from "@/components/quotation/LineItemsEditor";
import { QUOTE_TYPES, isRental } from "@/components/quotation/OptionCard";

const typeLabel = (t) => (QUOTE_TYPES.find(([v]) => v === t) || [null, "Sale"])[1];

export function ApproveOptionDialog({ options, open, onOpenChange, onConfirm }) {
  const [pick, setPick] = useState("");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="approve-option-dialog">
        <DialogHeader>
          <DialogTitle>Which option did the client accept?</DialogTitle>
          <DialogDescription>The quotation is marked Approved with this option recorded.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {options.map((o) => (
            <label key={o.letter} className={`flex items-start gap-3 border rounded-md p-3 cursor-pointer ${pick === o.letter ? "border-emerald-400 bg-emerald-50" : "border-slate-200"}`} data-testid={`approve-option-${o.letter}`}>
              <input type="radio" checked={pick === o.letter} onChange={() => setPick(o.letter)} className="mt-1" />
              <div>
                <div className="text-sm font-semibold text-slate-900">Option {o.letter} · {o.label || typeLabel(o.quote_type)}</div>
                <div className="text-xs text-slate-500">{fmtInr(itemsTotals(o.line_items || []).total)}{isRental(o.quote_type) ? " per month" : ""}</div>
              </div>
            </label>
          ))}
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="approve-option-cancel">Cancel</Button>
          <Button disabled={!pick} onClick={() => onConfirm(pick)} className="bg-emerald-600 hover:bg-emerald-700" data-testid="approve-option-confirm">Mark Approved</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
